const createSearchParams = (query = []) => {
  const searchParams = new URLSearchParams();
  query.forEach((q) => {
    searchParams.append(q.name, q.value);
  });
  return searchParams;
};
export {
  createSearchParams
};
//# sourceMappingURL=create-search-params.js.map
